// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.new-collections{
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    margin-bottom: 100px;
}
.new-collections h1{
    color: #171717;
    font-size: 50px;
    font-weight: 600;

}
.new-collections hr{
    width: 200px;
    height: 6px;
    border-radius: 10px;
    background: #252525;

}
.collections{
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    margin-top: 50px;
    gap: 30px;
}
@media(max-width:1280px){
   
    .new-collections h1{
        font-size: 40px;
    }
    .new-collections hr{
        width: 160px;
        height: 4px;
    }
    .collections{
        gap: 20px;
        margin-top: 30px;
    }

}
@media(max-width:1024px){
   
    .new-collections h1{
        font-size: 30px;
    }
    .new-collections hr{
        width: 120px;
        height: 3px;
    }
    .collections{
        gap: 15px;
        margin-top: 20px;
    }

}
@media(max-width:800px){
    .new-collections{
      
        gap: 6px;
    }
    .new-collections h1{
        font-size: 20px;
    }
    .new-collections hr{
        width: 100px;
 
    }
    .collections{
        gap: 5px; 
    }

}
@media(max-width:500px){
    
    
    .collections{
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 20px; 
    }

}`, "",{"version":3,"sources":["webpack://./src/Components/NewCollections/NewCollections.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,oBAAoB;AACxB;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;;AAEpB;AACA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,mBAAmB;;AAEvB;AACA;IACI,aAAa;IACb,sCAAsC;IACtC,gBAAgB;IAChB,SAAS;AACb;AACA;;IAEI;QACI,eAAe;IACnB;IACA;QACI,YAAY;QACZ,WAAW;IACf;IACA;QACI,SAAS;QACT,gBAAgB;IACpB;;AAEJ;AACA;;IAEI;QACI,eAAe;IACnB;IACA;QACI,YAAY;QACZ,WAAW;IACf;IACA;QACI,SAAS;QACT,gBAAgB;IACpB;;AAEJ;AACA;IACI;;QAEI,QAAQ;IACZ;IACA;QACI,eAAe;IACnB;IACA;QACI,YAAY;;IAEhB;IACA;QACI,QAAQ;IACZ;;AAEJ;AACA;;;IAGI;QACI,aAAa;QACb,8BAA8B;QAC9B,SAAS;IACb;;AAEJ","sourcesContent":[".new-collections{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 20px;\n    margin-bottom: 100px;\n}\n.new-collections h1{\n    color: #171717;\n    font-size: 50px;\n    font-weight: 600;\n\n}\n.new-collections hr{\n    width: 200px;\n    height: 6px;\n    border-radius: 10px;\n    background: #252525;\n\n}\n.collections{\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr 1fr;\n    margin-top: 50px;\n    gap: 30px;\n}\n@media(max-width:1280px){\n   \n    .new-collections h1{\n        font-size: 40px;\n    }\n    .new-collections hr{\n        width: 160px;\n        height: 4px;\n    }\n    .collections{\n        gap: 20px;\n        margin-top: 30px;\n    }\n\n}\n@media(max-width:1024px){\n   \n    .new-collections h1{\n        font-size: 30px;\n    }\n    .new-collections hr{\n        width: 120px;\n        height: 3px;\n    }\n    .collections{\n        gap: 15px;\n        margin-top: 20px;\n    }\n\n}\n@media(max-width:800px){\n    .new-collections{\n      \n        gap: 6px;\n    }\n    .new-collections h1{\n        font-size: 20px;\n    }\n    .new-collections hr{\n        width: 100px;\n \n    }\n    .collections{\n        gap: 5px; \n    }\n\n}\n@media(max-width:500px){\n    \n    \n    .collections{\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n        gap: 20px; \n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
